import { createContext, ReactNode, useReducer, JSX } from 'react'

import { authReducer, AuthState, Severity } from './AuthReducer'
import CustomSnackbar from '../components/Snackbar'
import { IPatientInfo } from '../views/Register/types'

interface Props {
  children?: ReactNode
}

export type AuthContextType = {
  errorMessage: string
  patient: IPatientInfo
  removeError: () => void
  savePatientData: (patient: IPatientInfo) => void
  handleAlert(open: boolean, message: string, severity?: Severity): void
}

export const initialPatient: IPatientInfo = {
  name: '',
  lastName: '',
  idNumber: '',
  mobile: '',
  addresses: [],
  birthdate: '',
  gender: '',
  photo_patient: '',
  age: '',
  document_type: '',
}

const authInitialState: AuthState = {
  errorMessage: '',
  patient: initialPatient,
  snack: {
    open: false,
    message: '',
    severity: undefined,
  },
}

const AccountContext = createContext<AuthContextType | null | boolean>(null)

const AuthProvider = ({ children }: Props): JSX.Element => {
  const [state, dispatch] = useReducer(authReducer, authInitialState)

  const handleAlert = (open: boolean, message: string, severity?: Severity): void =>
    dispatch({
      type: 'snack',
      payload: {
        open,
        message,
        severity,
      },
    })

  const savePatientData = (patient: IPatientInfo): void => {
    dispatch({
      type: 'patientData',
      payload: {
        patient: patient,
      },
    })
  }

  const removeError = (): void => {
    dispatch({ type: 'removeError' })
  }

  return (
    <AccountContext.Provider
      value={{
        ...state,
        removeError,
        savePatientData,
        handleAlert,
      }}
    >
      {children}
      <CustomSnackbar
        handleAlert={handleAlert}
        openAlert={state.snack.open}
        message={state.snack.message}
        severity={state.snack.severity}
      />
    </AccountContext.Provider>
  )
}

export { AuthProvider, AccountContext }
